/* eslint-disable camelcase */
import { LiveClient, LiveSchema } from '@deepgram/sdk';

// Deepgram types and interfaces
export type DeepgramLiveClient = LiveClient;
export type DeepgramLiveOptions = LiveSchema;

export interface DeepgramTranscriptResult {
  type: 'Results';
  channel_index: [number, number];
  duration: number;
  start: number;
  is_final: boolean;
  speech_final: boolean;
  channel: {
    alternatives: {
      transcript: string;
      confidence: number;
      words: {
        word: string;
        start: number;
        end: number;
        confidence: number;
      }[];
    }[];
  };
}

/**
 * Default options for Deepgram live transcription
 */
export const DEFAULT_DEEPGRAM_OPTIONS: DeepgramLiveOptions = {
  model: 'nova-3',
  smart_format: true,
  interim_results: false,
  encoding: 'linear16',
  sample_rate: 16000,
  language: 'multi',
  vad_events: true,
  endpointing: 100,
};
